module.exports = __webpack_public_path__ + "img/jylnicon3.e31e5aae.jpg";